import React from 'react';

const ReviewReplies = ({
  color = 'black',
  size = 12,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 158 157"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={color}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.127 2.166C0.00799847 6.185 0.0470032 5.925 0.0220032 56.25L0 100H7.5H15V57.508V15.017L71.75 14.758L128.5 14.5L128.794 7.25L129.088 0L70.794 0.000999451C13.037 0.00199945 12.46 0.0220003 8.127 2.166ZM38 29.706C37.175 30.008 35.445 31.21 34.155 32.377C29.006 37.038 29 37.094 29 79.302C29 118.601 29.006 118.713 31.27 122.102C35.29 128.12 38.466 128.997 56.25 128.998L72 129V140.777C72 155.546 72.746 157 80.32 157H85.527L99.438 143.062L113.349 129.125L130.605 128.812C149.447 128.471 150.56 128.149 155.438 121.615C157.44 118.934 157.5 117.69 157.5 79.177C157.5 35.057 157.507 35.109 150.701 30.96C147.626 29.084 145.369 29.01 93.5 29.083C63.8 29.124 38.825 29.405 38 29.706ZM129 64.5V72H93.5H58V64.5V57H93.5H129V64.5ZM115 93V100H86.5H58V93V86H86.5H115V93Z"
    />
  </svg>

);

export default ReviewReplies;
